// extracted by mini-css-extract-plugin
export default {"real-feel":"RealFeel_real-feel__ulLTt"};